import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { PropertyType } from '@gql';
import type { Feature } from '../search-context-utils';
export interface SearchFiltersContextValue {
  activeFilters: Feature[];
  allFeatures: Feature[];
  setActiveFilters: (features: Feature[]) => void;
  propertyTypes: PropertyType[];
  setPropertyTypes: (propertyTypes: PropertyType[]) => void;
  checkInDate: string | null;
  checkOutDate: string | null;
  setCheckInDate: React.Dispatch<React.SetStateAction<string | null>>;
  setCheckOutDate: React.Dispatch<React.SetStateAction<string | null>>;
  adultCount: number;
  setAdultCount: React.Dispatch<React.SetStateAction<number>>;
  childCount: number;
  setChildCount: React.Dispatch<React.SetStateAction<number>>;
  infantCount: number;
  setInfantCount: React.Dispatch<React.SetStateAction<number>>;
  petCount: number;
  setPetCount: React.Dispatch<React.SetStateAction<number>>;
  handlePetFriendlyToggle: (isChecked: boolean) => void;
  minNumberOfRooms: number;
  setMinNumberOfRooms: React.Dispatch<React.SetStateAction<number>>;
  minNumberOfBeds: number;
  setMinNumberOfBeds: React.Dispatch<React.SetStateAction<number>>;
  minNumberOfBathrooms: number;
  setMinNumberOfBathrooms: React.Dispatch<React.SetStateAction<number>>;
  minPrice: number | null;
  setMinPrice: React.Dispatch<React.SetStateAction<number | null>>;
  maxPrice: number | null;
  setMaxPrice: React.Dispatch<React.SetStateAction<number | null>>;
  guestCountHumanReadableValue: string;
}
const SearchFiltersContext = React.createContext<SearchFiltersContextValue | undefined>(undefined);
interface SearchFiltersProviderProps {
  value: SearchFiltersContextValue;
  children: React.ReactNode;
}
export const SearchFiltersProvider: React.FC<SearchFiltersProviderProps> = t0 => {
  const $ = _c(3);
  const {
    value,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <SearchFiltersContext.Provider value={value}>{children}</SearchFiltersContext.Provider>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const useSearchFilters = () => {
  const context = React.useContext(SearchFiltersContext);
  if (context === undefined) {
    throw new Error("useSearchFilters must be used within a SearchProvider");
  }
  return context;
};